export default __webpack_public_path__ + "static/media/taperule.e3ee19c6.png";